module.exports = __webpack_public_path__ + "img/galo_da_manha.d15e588b.png";